import {type ColorMode, getPreferredColorMode} from '../color-modes'
import {controller, target, targets} from '@github/catalyst'
import {isFeatureEnabled} from '@github-ui/feature-flags'

@controller
class AppearancePreviewElement extends HTMLElement {
  @target declare boxElement: HTMLElement
  @target declare activeLabel: HTMLElement
  @targets declare themePreviews: HTMLElement[]

  connectedCallback() {
    this.checkActive()
    window
      .matchMedia(`(prefers-color-scheme: ${this.getAttribute('data-mode')})`)
      .addEventListener('change', () => this.checkActive())
  }

  themePreview(e: Event) {
    const disc = e.currentTarget as HTMLElement
    if (!disc) {
      return
    }
    // If the `appearance_settings` feature flag is enabled, previews will not exist for high-contrast themes.
    // Instead, get the corresponding default-contrast theme’s preview.
    const theme = isFeatureEnabled('appearance_settings')
      ? disc.getAttribute('data-theme')?.replace(/_high_contrast$/, '')
      : disc.getAttribute('data-theme')
    for (const preview of this.themePreviews) {
      preview.hidden = preview.getAttribute('data-theme') !== theme
    }
  }

  previewReset() {
    const selectedTheme = this.boxElement.querySelector('input:checked') as HTMLInputElement
    // If the `appearance_settings` feature flag is enabled, previews will not exist for high-contrast themes.
    // Instead, get the corresponding default-contrast theme’s preview.
    const theme = isFeatureEnabled('appearance_settings')
      ? selectedTheme.value.replace(/_high_contrast$/, '')
      : selectedTheme.value
    for (const preview of this.themePreviews) {
      preview.hidden = preview.getAttribute('data-theme') !== theme
    }
  }

  checkActive() {
    if ((this.getAttribute('data-mode') as ColorMode) === getPreferredColorMode()) {
      this.boxElement.classList.add('Box--blue')
      this.activeLabel.hidden = false
    } else {
      this.boxElement.classList.remove('Box--blue')
      this.activeLabel.hidden = true
    }
  }
}
